/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import QueryString from 'qs';
import { useHistory } from 'react-router-dom';

import { useStore } from '@src/models';
import { ROUTES } from 'src/constants';

export const useScopeFilter = (path = 'scope') => {
  const {
    userStore,
    routerStore: {
      location: { search, pathname }
    },
    feed: {
      jobs: { setScope, ...jobs }
    }
  } = useStore();
  const history = useHistory();
  const scope = jobs[path];

  // update scope in search query this will trigger refetch jobs
  React.useEffect(() => {
    if (!userStore.user && !userStore.isFetching && pathname === ROUTES.resources) {
      setScope({ value: 'all', label: 'All resources' }, 'learningScope');
    }
  }, [userStore.user, userStore.isFetching]);

  // update scope in search query this will trigger refetch jobs
  React.useEffect(() => {
    const newQsObj = QueryString.parse(search, { ignoreQueryPrefix: true });

    const newQs = QueryString.stringify({ ...newQsObj, ...{ scope: scope.value } });

    history.push({
      search: newQs
    });
  }, [scope.value]);

  return [scope, setScope];
};
